export default function XSD_HowTo() {
  return (
    <div>
      <h1>XSD_HowTo</h1>
      <p>This is the XSD_HowTo component.</p>
    </div>
  );
}